// Pure JS Jalali (Solar Hijri) — tested & correct algorithm

function gregorianToJalali(gy, gm, gd) {
  var g_y = gy - 1600, g_m = gm - 1, g_d = gd - 1;
  var g_day = 365 * g_y + Math.floor((g_y + 3) / 4) - Math.floor((g_y + 99) / 100) + Math.floor((g_y + 399) / 400);
  var tmp = [0,31,28,31,30,31,30,31,31,30,31,30,31];
  for (var i = 0; i < g_m; i++) g_day += tmp[i+1];
  if (g_m > 1 && ((g_y % 4 === 0 && g_y % 100 !== 0) || g_y % 400 === 0)) g_day++;
  g_day += g_d;
  var j_day = g_day - 79;
  var j_np = Math.floor(j_day / 12053); j_day %= 12053;
  var jy = 979 + 33 * j_np + 4 * Math.floor(j_day / 1461);
  j_day %= 1461;
  if (j_day >= 366) { jy += Math.floor((j_day - 1) / 365); j_day = (j_day - 1) % 365; }
  var jMonths = [31,31,31,31,31,31,30,30,30,30,30,29];
  var jm = 0;
  for (jm = 0; jm < 12 && j_day >= jMonths[jm]; jm++) j_day -= jMonths[jm];
  return { jy: jy, jm: jm + 1, jd: j_day + 1 };
}

function jalaliToGregorian(jy, jm, jd) {
  var jy2 = jy - 979, jm2 = jm - 1, jd2 = jd - 1;
  var j_day = 365 * jy2 + Math.floor(jy2 / 33) * 8 + Math.floor(((jy2 % 33) + 3) / 4);
  var jMonths = [31,31,31,31,31,31,30,30,30,30,30,29];
  for (var i = 0; i < jm2; i++) j_day += jMonths[i];
  j_day += jd2;
  var g_day = j_day + 79;
  var gy = 1600 + 400 * Math.floor(g_day / 146097);
  g_day = g_day % 146097;
  var leap = true;
  if (g_day >= 36525) {
    g_day--;
    gy += 100 * Math.floor(g_day / 36524);
    g_day = g_day % 36524;
    if (g_day >= 365) g_day++;
    else leap = false;
  }
  gy += 4 * Math.floor(g_day / 1461);
  g_day %= 1461;
  if (g_day >= 366) { leap = false; g_day--; gy += Math.floor(g_day / 365); g_day = g_day % 365; }
  var gMonths = [31, leap ? 29 : 28, 31,30,31,30,31,31,30,31,30,31];
  var gm = 0;
  for (gm = 0; g_day >= gMonths[gm]; gm++) g_day -= gMonths[gm];
  return new Date(gy, gm, g_day + 1);
}

function pad(n) { return String(n).padStart(2, '0'); }

export function toJalaliParts(date) {
  try {
    const d = date instanceof Date ? date : new Date(date);
    if (isNaN(d.getTime())) return null;
    return gregorianToJalali(d.getFullYear(), d.getMonth()+1, d.getDate());
  } catch { return null; }
}

export function toGregorianDate(jy, jm, jd) {
  return jalaliToGregorian(jy, jm, jd);
}

export const toJalali = (date) => {
  if (!date) return '-';
  try {
    const d = new Date(date);
    if (isNaN(d.getTime())) return '-';
    const p = gregorianToJalali(d.getFullYear(), d.getMonth()+1, d.getDate());
    return `${p.jy}/${pad(p.jm)}/${pad(p.jd)}`;
  } catch { return '-'; }
};

export const toJalaliDateTime = (date) => {
  if (!date) return '-';
  try {
    const d = new Date(date);
    if (isNaN(d.getTime())) return '-';
    const p = gregorianToJalali(d.getFullYear(), d.getMonth()+1, d.getDate());
    return `${p.jy}/${pad(p.jm)}/${pad(p.jd)} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
  } catch { return '-'; }
};

export const fromJalali = (jalaliStr) => {
  if (!jalaliStr) return null;
  try {
    const parts = jalaliStr.split('/').map(Number);
    if (parts.length !== 3 || parts.some(isNaN)) return null;
    return jalaliToGregorian(parts[0], parts[1], parts[2]);
  } catch { return null; }
};

export const jalaliMonthName = (date) => {
  const months = ['Hamal','Saur','Jawza','Saratan','Asad','Sumbula','Mizan','Aqrab','Qaws','Jadi','Dalwa','Hut'];
  try {
    const d = new Date(date);
    const p = gregorianToJalali(d.getFullYear(), d.getMonth()+1, d.getDate());
    return months[p.jm - 1];
  } catch { return ''; }
};

export const currentJalaliDate = () => toJalali(new Date());
export const currentJalaliYear = () => {
  try { return gregorianToJalali(new Date().getFullYear(), new Date().getMonth()+1, new Date().getDate()).jy; }
  catch { return 1403; }
};
